import {
  RedoBadge,
  type RedoBadgeColor,
  type RedoBadgeSize,
} from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { memo } from "react";

const LOT_COLORS: RedoBadgeColor[] = [
  "brand",
  "success",
  "warning",
  "grayBlue",
  "blueLight",
  "blue",
  "indigo",
  "purple",
  "pink",
  "orange",
];

function hashLotColor(lotNumber: string): RedoBadgeColor {
  let hash = 5381;
  for (let i = 0; i < lotNumber.length; i++) {
    hash = ((hash << 5) + hash + lotNumber.charCodeAt(i)) | 0;
  }
  const index = Math.abs(hash) % LOT_COLORS.length;
  return LOT_COLORS[index] ?? "brand";
}

function formatExpiration(d: Date | string | null | undefined): string | null {
  if (!d) {
    return null;
  }
  const dt = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(dt.getTime())) {
    return null;
  }
  return dt.toISOString().slice(0, 10);
}

export const LotBadge = memo(function LotBadge({
  lotNumber,
  expirationDate,
  quantity,
  size = "xs",
}: {
  lotNumber: string;
  expirationDate?: Date | string | null;
  quantity?: number;
  size?: RedoBadgeSize;
}) {
  const expText = formatExpiration(expirationDate);
  const qtyText = quantity != null ? ` × ${quantity}` : "";
  const text = expText
    ? `${lotNumber}${qtyText} · Exp ${expText}`
    : `${lotNumber}${qtyText}`;
  return <RedoBadge color={hashLotColor(lotNumber)} size={size} text={text} />;
});
